import clsx from "clsx";
import { cva, VariantProps } from "cva";
import { type ChangeEvent, type InputHTMLAttributes, useId } from "react";

import { CheckIcon } from "../Icon";
import styles from "./index.module.css";

export const variants = cva({
  variants: {
    variant: {
      fill: styles.fill,
      icon: styles.icon,
      hug: styles.hug,
    },
    align: {
      left: styles.left,
      center: styles.center,
      right: styles.right,
    },
    checked: {
      true: styles.checked,
    },
    disabled: {
      true: styles.disabled,
    },
  },
  defaultVariants: {
    variant: "fill",
    align: "left",
  },
});

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> &
  VariantProps<typeof variants> & {
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  };

export const Checkbox = ({
  disabled,
  id,
  className,
  variant,
  align,
  checked,
  children,
  ...props
}: Readonly<CheckboxProps>) => {
  const controlId = useId();

  return (
    <label className={clsx(variants({ variant, align, disabled }), styles.base, className)}>
      <span className={clsx(variants({ checked, disabled }), styles.input)}>
        <input
          className={styles.nativeInput}
          id={id ?? controlId}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          {...props}
        />
        <span className={clsx(variants({ checked, disabled }), styles.iconWrapper)}>
          <CheckIcon size="s" color="secondary" aria-hidden={true} />
        </span>
      </span>
      {!!children && <span className={clsx(variants({ disabled }), styles.label)}>{children}</span>}
    </label>
  );
};
